import { Box, Typography } from "@mui/material";
import RequestsTable from "./requests-table";

const GolfCartRequestsPage = () => {
  return (
    <Box p={"30px"}>
      <Typography mb={{ xs: 2, md: 4 }} fontSize={"20px"} fontWeight={600}>
        Golf Cart Requests
      </Typography>

      <RequestsTable />
    </Box>
  );
};

export default GolfCartRequestsPage;
